import vm from '@/main'
import { SCHEMEBASE } from '@/assets/js/const'
export const getDeviceId = () => {
  if (!vm.$storage.get('h5_deviced_id')) {
    vm.$storage.set(
      'h5_deviced_id',
      Number(
        Math.random()
          .toString()
          .substr(3, length) + Date.now()
      ).toString(36)
    )
  }
  return vm.$storage.get('h5_deviced_id')
}
// 获取当前页面运行环境
export const plateForm = () => {
  const u = navigator.userAgent.toLowerCase()
  const isAndroid = u.indexOf('android') > -1 || u.indexOf('linux') > -1 // android
  const isIOS = Boolean(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i)) || u.indexOf('mac os x') > -1 // ios终端
  const isPc = !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
  const isWx = (() => {
    if (u.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    }
    return false
  })()
  // 是否飞书环境
  const isFs = (() => {
    if (u.includes('larklocale')) {
      return true
    }
    return false
  })()
  const isAliPay = /AlipayClient/i.test(u)
  const app = ((ua) => {
    if (/SsCapp\//i.test(ua) || /shopshops\//i.test(ua)) {
      return 'scapp'
    }
    if (/SsGapp\//i.test(ua) || /shopshopHots\//i.test(ua)) {
      return 'sgapp'
    }
    return ''
  })(u)
  // 支付宝小程序环境
  const isAliPayMiniApp = /miniprogram/i.test(u)
  const version = ((ua) => {
    if (app === 'scapp') {
      const version = ua.match(/SsCapp\/([\d.]+)/i) || ua.match(/shopshops\/([\d.]+)/i)
      return version ? version[1] : '0.0.0'
    }
    if (app === 'sgapp') {
      const version = ua.match(/SsGapp\/([\d.]+)/i) || ua.match(/shopshopHots\/([\d.]+)/i)
      return version ? version[1] : '0.0.0'
    }
    return ''
  })(u)

  return {
    os: (() => {
      if (isWx) return 'wxClient'
      if (isFs) return 'feishu'
      // 支付宝小程序环境
      if (isAliPayMiniApp) return 'alipayMini'
      if (isAliPay) return 'alipayClient'
      if (isIOS) return 'ios'
      if (isAndroid) return 'android'
      if (isPc) return 'PC'
      return 'H5'
    })(),
    app,
    version,
    isIOS,
    isAndroid,
    isPc
  }
}

export const isActivityPath = ()=>{
  if( process.env.NODE_ENV === 'development' ){
    return location.pathname.match(/^\/activity\//ig);
  }else{
    return location.pathname.match(/^\/(en|release-en|uat-en|test-en)\/(activity)/ig)
  }
}

export const isRoomPath = ()=>{
  return location.pathname.match(/\/app\/room\//ig);
}

// export const isAppPath = ()=>{
//   if( process.env.NODE_ENV === 'development' ){
//     return location.pathname.match(/^\/(app\/|anchor|store|order_detail|repay)/);
//   }else{
//     return location.pathname.match(/^\/(en|release-en|uat-en|test-en)\/(app\/|anchor|store|order_detail|repay)/ig)
//   }
// }


// 获取对象参数
export const getQueryObj = (url = window.location.href) =>{
  const params = {};
  const urls = url.split('?');
  const arr = urls[1] ? urls[1].split('&') : [];
  for (let i = 0, l = arr.length; i < l; i++) {
    const a = arr[i].split('=');
    params[a[0]] = a[1];
  }
  return params;
}

export const formatUrlQuery = (old) => {
  let newone,
    query = window.location.search
  if (old.indexOf('?') == -1) {
    newone = old + query
  } else {
    newone = old + query.replace('?', '&')
  }
  return newone
}

export const getUrlQuery = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}


export const getUrlFragment = (url = window.location.hash) => {
  let params = {}
  let urls = url.split('#')
  let arr = urls[1] ? urls[1].split('&') : []
  for (let i = 0, l = arr.length; i < l; i++) {
      let a = arr[i].split('=')
      params[a[0]] = a[1]
  }
  return params
}


export const GetSlideDirection = (startX, startY, endX, endY) => {
  //手指滑动的方向 1：向上滑，2：向下滑，3：向左滑，4：向右滑,0：未滑动
  const MINMOVE = 15
  let dy = endY - startY;
  let dx = endX - startX;
  let result = 0;
  //如果滑动距离太短 
  if (Math.abs(dx) < MINMOVE && Math.abs(dy) < MINMOVE) {
    return result;
  }
  let angle = GetSlideAngle(dx, dy);
  if (angle >= -45 && angle < 45) {
    result = 4;
  } else if (angle >= 45 && angle < 135) {
    result = 2;
  } else if (angle >= -135 && angle < -45) {
    result = 1;
  } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
    result = 3;
  }
  return result;
}
const GetSlideAngle = (dx, dy) => {
  return Math.atan2(dy, dx) * 180 / Math.PI;
}
export const formatDate = (times, fmt, showPeriod, showEn) => {
    // author: meizz
    const date = new Date(times)
    const M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    const o = {
        'M+': showEn && !lanEnv() ? M[date.getMonth()] : date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, String(date.getFullYear())).substr(4 - RegExp.$1.length)
    }
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 || (showEn && !lanEnv() && k === 'M+') ? o[k] : ('00' + o[k]).substr(String(o[k]).length)
            )
        }
    }
    if (showPeriod && !lanEnv()) {
        const hours = date.getHours()
        if (hours > 12) {
            if (showEn && !lanEnv()) {
                let hour = fmt.substr(-5, 2) - 12
                fmt = fmt.replace(/\d{2}:/g, hour + ':')
                return `${fmt}pm`
            }
            const splitDate = fmt.split(' ')
            const curDate = splitDate[0]
            const fullTime = splitDate[1]
            const splitTime = fullTime.split(':')
            const curHour = splitTime[0] - 12
            const curTime = splitTime[1]
            return `${curDate} ${curHour}:${curTime}pm`
        }
        return `${fmt}am`
    }
    return fmt
}
export const scheme = (target) => {
  return new Promise((resolve, reject) => {
    window.location.href = target
    console.log('target:::', target)
    let isChange = false
    let property = 'hidden', eventName = 'visibilitychange'
    if (typeof document.msHidden !== 'undefined') {
      property = 'msHidden'
      eventName = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      property = 'webkitHidden'
      eventName = 'webkitvisibilitychange'
    }
    const pageChange = (e) => {
      isChange = true
      if (document[property] || e.hidden || document.visibilityState == 'hidden') {
        timer && clearTimeout(timer)
        resolve()
      } else {
        reject()
      }
      document.removeEventListener(eventName, pageChange)
      document.removeEventListener('baiduboxappvisibilitychange', pageChange)
    }
    document.addEventListener(eventName, pageChange, false)
    document.addEventListener('baiduboxappvisibilitychange', pageChange, false)
    let timer = setTimeout(() => {
      if (isChange) {
        timer && clearTimeout(timer)
        return
      }
      document.removeEventListener(eventName, pageChange)
      document.removeEventListener('baiduboxappvisibilitychange', pageChange)
      if (!document.hidden && !isChange) {
        reject()
      }
      isChange = true
    }, 3000)
  })
}
export const formatScheme = () => {
  let href = window.location.href
  let search = window.location.search
  let isRoom = href.indexOf('/app/room/') !== -1
  let fromApp = search.indexOf('jumpType') !== -1
  if (!isRoom) {
    return SCHEMEBASE
  }
  if (fromApp) {
    return SCHEMEBASE + `?jumpType=${getUrlQuery('jumpType')}&jumpId=${getUrlQuery('jumpId')}`
  }
  if (isRoom) {
    return SCHEMEBASE
  }
  return SCHEMEBASE
}


// 是否支持 webp格式
export const isSupportWebp = () => {
  try {
      return (
          document
              .createElement('canvas')
              .toDataURL('image/webp', 0.5)
              .indexOf('data:image/webp') === 0
      )
  } catch (err) {
      return false
  }
}




// 加载css
export const renderLink = (src) => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = src
  document.head.appendChild(link)
}

// 异步加载script
export const renderScript = (src) => {
  return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'

      if (script.readyState) {
          //IE
          script.onreadystatechange = () => {
              if (script.readyState == 'loaded' || script.readyState == 'complete') {
                  script.onreadystatechange = null
                  resolve()
              }
          }
      } else {
          //Others
          script.onload = () => {
              resolve()
          }
      }

      script.onerror = () => {
          reject(Error(`${src}load error!`))
      }

      script.src = src
      // script.src = `${src}?time=${Number(Date.parse(new Date()))}`
      document.body.appendChild(script)
  })
}



/**
 * 输出数组所有项的排列组合
 * eg. pac([1, 2, 3]) => [ [ 1 ], [ 1, 2 ], [ 1, 2, 3 ], [ 1, 3 ], [ 2 ], [ 2, 3 ], [ 3 ] ]
 * @param {array} ori 目标数组
 * @returns {array[array]}
 */
export const pac = (ori) => {
    if (Object.prototype.toString.call(ori) !== '[object Array]') {
        throw new Error('入参必须是数组')
    }
    const result = []
    ori.forEach((item, index, arr) => {
        result.push([item])
        const rest = arr.slice(index + 1)
        if (rest.length) {
            if (rest.length === 1) {
                result.push([item, ...rest])
            } else {
                pac(rest).forEach((i) => {
                    result.push([item, ...i])
                })
            }
        }
    })
    return result
}



/**
 * 获取滚动条滚动的高度
 * @returns {number}
 */
 export const getScrollTop = () => {
  let scroll_top = 0
  if (document.documentElement && document.documentElement.scrollTop) {
      scroll_top = document.documentElement.scrollTop
  } else if (document.body) {
      scroll_top = document.body.scrollTop
  }
  return scroll_top
}

// 当前域名（2022-07-29 域名迁移需求, 分享到app外的域名应该都是shopshopslive.com其他的都是shopshops.top）
export const CURRENT_HOST_NAME = location.hostname.includes('shopshopslive.com')?'shopshopslive.com': 'shopshops.top';